import {ePost,eGet} from '../libs/ajax.js';

let curHost = window.location.host;
let umcHost = '';
if(curHost.includes('wankacn.com')){
    umcHost = 'https://umc.wankacn.com';
}else if(window.location.protocol=='https:'){
    umcHost = 'https://umc.gm825.net';
}else{
    umcHost = 'http://umc.gm825.net';
}

export default {
    // auc权限
    getMessageCount:(data,options)=>{
        return eGet(umcHost+'/api/getMessageCount',data,options);
    },
    // 获取消息列表
    getMessageList:(data,options)=>{
        return eGet(umcHost+'/api/getMessage',data,options);
    },
    // 设置已读
    markRead:(data,options)=>{
        return ePost(umcHost+'/api/markRead',data,options);
    },
    // 批量设置已读
    batchMarkingRead:(data,options)=>{
        return ePost(umcHost+'/api/batchMarkingRead',data,options);
    },
}
